$(document).ready(function () {
// Get Started 1st step
$(document).on("click", ".letsgetStarted", function () {
  var selectValue = $(".select__step1").val();
  if (selectValue == "") {
    $(".letsget-started").addClass("show-message");
    $(this)
      .parents(".customize-ring__start")
      .find(".customizer-navigation-message")
      .html(
        '<span class="error--message">Please select an option to continue</span>'
      );
  } else {
    $(".letsget-started").removeClass("show-message");
    $(this)
      .parents(".customize-ring__start")
      .find(".customizer-navigation-message")
      .html("");
    $(this).parents(".cust-step-1").removeClass("active");
    $(".cust-step-2").addClass("active");
  }
  $(".customize-ring__step--selections").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow:
      '<div class="b-prevArrow"><img src="https://cdn.shopify.com/s/files/1/0105/6289/5930/files/next-arrow.webp?v=1683701526"></div>',
    nextArrow:
      '<div class="b-nextArrow"><img src="https://cdn.shopify.com/s/files/1/0105/6289/5930/files/next-arrow.webp?v=1683701526"></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
        },
      },
      {
        breakpoint: 766,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });
});
$(document).on("click", ".customize-ring__step--selection", function () {
  $(this).each(function () {
    var multipleValue = $(this).attr("data-title");
    if ($(this).parents().hasClass("multiple-selection")) {
      $(this).toggleClass("active-selection");
      if (
        $(this).parents(".multiple-selection").find(".active-selection")
          .length > 0
      ) {
        $('input[name="contact[Stone Type]"]').val(multipleValue);
      } else {
        $('input[name="contact[Stone Type]"]').val("");
      }
    } else {
      $(this).addClass("active-selection");
      $('input[name="contact[Stone Shape]"]').val(multipleValue);
      $(this).siblings().removeClass("active-selection");
      $(this)
        .parents(".cust-step-4")
        .find('input[name="contact[Setting]"]')
        .val(multipleValue);
      $(this)
        .parents(".cust-step-5")
        .find('input[name="contact[Precious Metal]"]')
        .val(multipleValue);
    }
  });
});
$(document).on("click", ".customizer-navigation__next", function () {
  $(this)
    .parents(".customize-ring__step")
    .find(".step--field")
    .each(function () {
      var inputValue = $(this).val();
      if (inputValue == "") {
        $(this)
          .parents(".customize-ring__step")
          .find(".customizer-navigation-message")
          .addClass("show-message")
          .html(
            '<span class="error--message">Please select an option to continue</span>'
          );
      } else {
        $(this)
          .parents(".customize-ring__step")
          .find(".customizer-navigation-message")
          .removeClass("show-message")
          .html("");
        $(this).parents(".customize-ring__step").removeClass("active");
        $(this).parents(".customize-ring__step").next().addClass("active");
      }
    });

  $(this)
    .parents(".customize-ring__step")
    .find(".customize-ring__fields")
    .each(function () {
      if (
        $(this).val() == "" ||
        $(this).val() != "" ||
        $(this).is(":checked")
      ) {
        $(this).parents(".customize-ring__step").removeClass("active");
        $(this).parents(".customize-ring__step").next().addClass("active");
      }
    });
  $(this)
    .parents(".customize-ring__step")
    .find(".customize-ring__step--selection.active-selection")
    .each(function () {
      var dataTitle = $(this).attr("data-title");
      var dataDesc = $(this).attr("data-description");
      var dataImage = $(this).attr("data-image");
      var dataStepTitle = $(this).attr("data-step-title");
      $(".customize-ring__step--summary").append(
        '<div class="summary-wrap" data-step-section="' +
          dataStepTitle +
          '">' +
          '<div class="summary-category">' +
          '<div class="summary-heading">' +
          dataStepTitle +
          "</div>" +
          '<img src="' +
          dataImage +
          '">' +
          "</div>" +
          '<div class="summary-content">' +
          '<div class="summary-info">' +
          '<div class="summary-info--title">' +
          dataTitle +
          "</div>" +
          '<div class="summary-info--description">' +
          dataDesc +
          "</div>" +
          "</div>" +
          "</div>" +
          '<div class="summary-action"></div>' +
          "</div>"
      );
    });
  if ($(this).parents(".customize-ring__step").hasClass("cust-step-8")) {
    $(this).parents(".customize-ring__step").removeClass("active");
    $(this).parents(".customize-ring__step").next().addClass("active");
  }
  if ($(this).parents(".customize-ring__step").hasClass("cust-step-6")) {
    //$(this).parents(".customize-ring__step").removeClass("active");
    //$(this).parents(".customize-ring__step").next().addClass("active");
    var customBandSize = $(this).parents(".customize-ring__step").find(".contact_custom-band-ring-top").val();
    console.log(customBandSize)
    if ( customBandSize != "" && customBandSize != null   )
    {
      if ($(".summary-wrap[data-step-section='Custom Band Info']").length == 0 )
      {
         $(".customize-ring__step--summary").append(
        '<div class="summary-wrap" data-step-section="Custom Band Info">' +
          '<div class="summary-category">' +
          '<div class="summary-heading">Customize Band Ring</div>' +
          '<img src="https://cdn.shopify.com/s/files/1/0563/2727/4695/t/2/assets/moreinfo-img.png">' +
          "</div>" +
          '<div class="summary-content">' +
          '<div class="summary-info">'+
          '<div class="summary-info--title">Customize Band Ring</div>'+
          '<div class="summary-info--description">'+
          "" +
          customBandSize +
          "" +
          "</div>" +
          "</div>" +
          "</div>" +
          '<div class="summary-action"></div>' +
          "</div>"
      );
      }
      else
      {
        $(".summary-wrap[data-step-section='Custom Band Info']").find(".summary-info--description").text(customBandSize);
      }
     
    }
  }

  if ($(this).parents(".customize-ring__step").hasClass("cust-step-7")) {
    var ringSize = $('input[name="contact[Ring Size]"]').val();
    var budgetRing = "";
    $('input[name="contact[Budget]"]').each(function () {
      if ($(this).is(":checked")) {
        budgetRing += $(this, ":checked").val();
      }
    });
    var textAreaValue = $('textarea[name="contact[Additional Notes]"]').val();
    var uploadFile = $(".inputfile").val();
    var fileNumber = $(".custom-design-upload").length;
    var addInfoHtml = "";
    if (ringSize != "") {
      addInfoHtml +=
        '<div class="summary-info">' +
        '<div class="summary-info--title">Size</div>' +
        '<div class="summary-info--description">' +
        ringSize +
        "</div>" +
        "</div>";
    }
    if (budgetRing != "") {
      addInfoHtml +=
        '<div class="summary-info">' +
        '<div class="summary-info--title">Budget</div>' +
        '<div class="summary-info--description">' +
        budgetRing +
        "</div>" +
        "</div>";
    }
    if (textAreaValue != "") {
      addInfoHtml +=
        '<div class="summary-info">' +
        '<div class="summary-info--title">Additional Notes</div>' +
        '<div class="summary-info--description">' +
        textAreaValue +
        "</div>" +
        "</div>";
    }
    if (fileNumber != 0) {
      addInfoHtml +=
        '<div class="summary-info">' +
        '<div class="summary-info--title">Attachment</div>' +
        '<div class="summary-info--description">' +
        "<span>Attached File (" +
        fileNumber +
        ")</span>" +
        "</div>" +
        "</div>";
    }
    if (
      ringSize != "" ||
      budgetRing != "" ||
      textAreaValue != "" ||
      fileNumber != 0
    ) {
      $(".customize-ring__step--summary").append(
        '<div class="summary-wrap" data-step-section="Additional Info">' +
          '<div class="summary-category">' +
          '<div class="summary-heading">Additional Info</div>' +
          '<img src="https://cdn.shopify.com/s/files/1/0563/2727/4695/t/2/assets/moreinfo-img.png">' +
          "</div>" +
          '<div class="summary-content">' +
          "" +
          addInfoHtml +
          "" +
          "</div>" +
          '<div class="summary-action"></div>' +
          "</div>"
      );
    }
  }

  $(".customize-ring__step--selections").slick("refresh");

  $(".customize-ring__step--selections").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow:
      '<div class="b-prevArrow"><img src="https://cdn.shopify.com/s/files/1/0105/6289/5930/files/next-arrow.webp?v=1683701526"></div>',
    nextArrow:
      '<div class="b-nextArrow"><img src="https://cdn.shopify.com/s/files/1/0105/6289/5930/files/next-arrow.webp?v=1683701526"></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
        },
      },
      {
        breakpoint: 766,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });
});

$(document).on("click", 'input[name="contact[Budget]"]', function () {
  if ($(this).is(":checked")) {
    $(this).attr("checked", "checked");
  }
});
$(document).on("change", "#customizer-attachment-file", function () {
  var files = $("#customizer-attachment-file")[0].files;
  console.log(files);
  var fd = new FormData();
  if (files.length > 0) {
    fd.append("file", files[0]);
    $.ajax({
      url: "https://upbrighters.com/capucelli/upload.php",
      type: "post",
      data: fd,
      dataType: "json",
      contentType: false,
      processData: false,
      beforeSend: function () {
        $(".s-upload__button").html("Loading....");
      },
      success: function (response) {
        console.log(response)
        var extension = response.extension;
        var path = response.path;
        var id = response.id;
        var imageName = response.upload_image;
        $(".s-upload__button").html("Add Image");
        $(".upload--file").append(
          '<span class="custom-design-upload">' +
            '<input type="hidden" name="image_id" value="' +
            id +
            '">' +
            '<input type="hidden" name="image_name" value="' +
            imageName +
            '">' +
            '<span class="image-cross">X</span>' +
            '<img src="https://upbrighters.com/capucelli/' +
            path +
            '"></span>'
        );
        $("#customizer-attachment-file").val("");
      },
    });
  }
  else{
    var uploadFile = $(".inputfile").val();
    var fileNumber = $(".custom-design-upload").length;
     var addInfoHtml =
        '<div class="summary-info">' +
        '<div class="summary-info--title">Attachment</div>' +
        '<div class="summary-info--description">' +
        "<span>Attached File (" +
        fileNumber +
        ")</span>" +
        "</div>" +
        "</div>";
    
    if (uploadFile != "") {
      $(".customize-ring__step--summary").append(
        '<div class="summary-wrap" data-step-section="Additional Info">' +
          '<div class="summary-category">' +
          '<div class="summary-heading">Additional Info</div>' +
          '<img src="https://cdn.shopify.com/s/files/1/0563/2727/4695/t/2/assets/moreinfo-img.png">' +
          "</div>" +
          '<div class="summary-content">' +
          "" +
          addInfoHtml +
          "" +
          "</div>" +
          '<div class="summary-action"></div>' +
          "</div>"
      );
  }
  }
});
$(document).on("click", ".image-cross", function () {
  $(this).each(function () {
    var deleteId = $(this)
      .parents(".custom-design-upload")
      .find('input[name="image_id"]')
      .val();
    var deleteImage = $(this)
      .parents(".custom-design-upload")
      .find('input[name="image_name"]')
      .val();
    $.ajax({
      url: "https://upbrighters.com/capucelli/delete.php",
      method: "POST",
      data: { id: deleteId, upload_image: deleteImage },
      success: function (data) {
        if ($(".custom-design-upload").length == 0) {
          $(".inputfile").val("");
        }
      },
    });
    $(this).parents(".custom-design-upload").remove();
  });
});
// $(document).on("click", "input[type=submit]", function () {
//   if (
//     $(this)
//       .parents(".customize-ring__step")
//       .find('input[name="contact[name]"]')
//       .val() != "" &&
//     $(this)
//       .parents(".customize-ring__step")
//       .find('input[name="contact[email]"]')
//       .val() != ""
//   ) {
//     $(this).parents(".customize-ring__step").removeClass("active");
//     $(".customize-ring__success").addClass("active");
//   }
// });

$(document).on("click", ".customizer-navigation__prev", function () {
  $(this).parents(".customize-ring__step").removeClass("active");
  $(this).parents(".customize-ring__step").prev().addClass("active");
  $(".customize-ring__step--selections").slick("refresh");
  $(this).each(function () {
    if ($(this).parents(".customize-ring__step").hasClass("cust-step-8")) {
      $(this)
        .parents(".customize-ring__step")
        .find('.summary-wrap[data-step-section="Additional Info"]')
        .remove();
    } else if (
      $(this).parents(".customize-ring__step").hasClass("cust-step-6")
    ) {
      $('.summary-wrap[data-step-section="Precious Metal"]').remove();
    } else if (
      $(this).parents(".customize-ring__step").hasClass("cust-step-5")
    ) {
      $('.summary-wrap[data-step-section="Setting"]').remove();
    } else if (
      $(this).parents(".customize-ring__step").hasClass("cust-step-4")
    ) {
      $('.summary-wrap[data-step-section="Stone Shape"]').remove();
    } else if (
      $(this).parents(".customize-ring__step").hasClass("cust-step-3")
    ) {
      $('.summary-wrap[data-step-section="Stone Type"]').remove();
    } else {
    }
  });
});

$(document).on("click", ".summary-action", function () {
  var dataStep = $(this)
    .parents(".summary-wrap")
    .find(".summary-heading")
    .text();
  $(".customize-ring__step--selections").slick("refresh");
  $(".customize-ring__step").each(function () {
    if ($(this).attr("data-step-title") == dataStep) {
      $(this).addClass("active");
      $(".cust-step-8").removeClass("active");
    }
  });
  if (
    $(this).parents(".summary-wrap").find(".summary-heading").text() ==
    "Stone Type"
  ) {
    $(this).parents(".customize-ring__step--summary").html("");
  } else {
    $(this)
      .parents(".summary-wrap")
      .prev(".summary-wrap")
      .nextAll(".summary-wrap")
      .remove();
  }
});
  $("input#contact_custom-band-ring").on("input", function(){
    $(".contact_custom-band-ring-top").val($(this).val().trim())
  })
  });